import * as styles from './index.module.scss';

import { useContext } from 'react';
import { useRouter } from 'next/router';

import { SiteContext } from '@/contexts/site-context';
import { cleanHeadline, formatPhoneNumber, swapPhone } from '@/helpers/helpers';
import { trackEvent } from '@/helpers/helpers_tracking';
import { QueryParamElement } from '@/components/QueryParamElement';
import DailyCount from '@/components/DailyCount';
import HeroBullets from '@/components/HeroBullets';
import HeroTags from '@/components/HeroTags';
import LocationLabel from '@/components/LocationLabel';

import PhoneIcon from 'svgs/redesign/phone.svg';
import CaretIcon from 'svgs/caret.svg';

const defaultHeadline = 'Get Home Repair Help Fast!';
const defaultSubheadline = 'Get connected to a local pro right when you need one.';

const HeroCategory = (props) => {
  const [site] = useContext(SiteContext);
  const headline = props.category?.headline || defaultHeadline;
  const subheadline = swapPhone(cleanHeadline(props.category?.subheadline || defaultSubheadline, site.location), site.phone_number);

  const router = useRouter();

  const handleClick = () => {
    try {
      trackEvent({
        event_type: 'conversion',
        event_category: 'form',
        event_action: 'start'
      });
      console.debug('event tracked');
    } catch (e) {
      console.debug('event not tracked', e);
    }
    router.push(`${props.category.use_custom_question_flow ? '/cf' : '/flow'}/${props.category.url_slug}`);
  };

  return (
    <div className={styles['hero-category-container']}>
      <div className={`${styles['container']} container`}>
        <LocationLabel />
        <QueryParamElement element="h1" queryParam="h1" fallbackText={headline} />
        {!props.category?.hideTags && <HeroTags />}
        <QueryParamElement element="h2" queryParam="h2" fallbackText={subheadline} injectFallback />
        <div className={styles['category-trigger-container']}>
          {props.category?.showPhoneNumber && (
            <a
              href={`tel:${site.phone_number}`}
              className="button large"
              onClick={() => {
                try {
                  trackEvent({
                    event_type: 'conversion',
                    event_category: 'phone',
                    event_action: 'click'
                  });
                  console.debug('event tracked');
                } catch (e) {
                  console.debug('event not tracked', e);
                }
              }}
            >
              <div className="icon-container">
                <PhoneIcon />
              </div>
              {formatPhoneNumber(site.phone_number)}
            </a>
          )}
          <div className={`button large ${props.category?.showPhoneNumber ? 'alt' : ''}`} onClick={() => handleClick()}>
            {props.category?.cta_copy ? props.category.cta_copy : 'Get a Quote'}{' '}
            <div className="icon-container">
              <CaretIcon />
            </div>
          </div>
        </div>
        <DailyCount count={props.daily_count} />
        <HeroBullets category={props.category} />
      </div>
    </div>
  );
};

export default HeroCategory;
